import { memo } from 'react';

import { Loader } from 'components/common';
import { styled } from '@mui/material';

const FileItemSkeletonWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'white',
  borderRadius: '8px',
  width: '100%',
  maxWidth: '208px',
  aspectRatio: '1 / 1',
}));

const FileItemSkeletonBase = () => (
  <FileItemSkeletonWrapper>
    <Loader />
  </FileItemSkeletonWrapper>
);

export const FileItemSkeleton = memo(FileItemSkeletonBase);
